// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","834":"a9a7754c"}[chunkId] || chunkId) + "-" + {"108":"88bb0e1049928eeb6d29","245":"e0ca234b9088b6f0a174","452":"1ed9ae99bf2cb8bf253a","453":"08bb6f42c391fc0d99e5","834":"83a4a780a86edb1f9ad0"}[chunkId] + ".js";
};